/* eslint-disable */
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import { Add } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { getCacheData } from "../../services/CacheService";
import WaitingDialog from "../../utils/WaitingDialog";

const initialState = {
  id_lc_material: null,
  descripcion: "",
};

const nameItemText = "Materiales de Lente de Contacto";
//
// ########################################################################### 
//
const SolucionLimpiezaMaterialLCDialog = ({
  onSave,
  onClose,
  setMessage,
  setShowMessage,
}) => {
  const [itemCrudLocal, setItemCrudLocal] = useState(initialState);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [lcMateriales, setLcMateriales] = useState([]);
  const [valueACLcMaterial, setValueACLcMaterial] = useState({
    id: "",
    label: "",
  });
  const [inputValueACLcMaterial, setInputValueACLcMaterial] = useState("");
  //
  // ################################################################################
  //
  useEffect(() => {
    loadLcMateriales();
  }, []);
  //
  // ################################################################################
  //
  const handleSave = () => {
    if (valueACLcMaterial.id === null || valueACLcMaterial.id === "") {
      setMessage({
        severity: "error",
        messageText: "Debes seleccionar el Material",
      });
      setShowMessage(true);
      return;
    }
    save();
  };
  //
  // ########################################################################## 
  //
  const save = async () => {

    let _itemCrud = {
      id_lc_material: valueACLcMaterial.id,
      descripcion_lc_material: valueACLcMaterial.label,
    };

    const success = onSave(_itemCrud);

    if (success) {
      setValueACLcMaterial(null);
      setInputValueACLcMaterial("");
      setItemCrudLocal(initialState);
    }
  };
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  const loadLcMateriales = async () => {
    const response = await getCacheData("lc_material")
    if (response.ok) {
      let _response = response.data.data;
      let _lcMateriales = [];
      _response.forEach((item) => {
        _lcMateriales.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setLcMateriales(_lcMateriales);
    } else {
      setLcMateriales([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
          }
          handleCloseDialog();
        }}
        disableEscapeKeyDown={true}
        maxWidth="sm"
        fullWidth={true}
        scroll="paper"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {nameItemText}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Autocomplete
                id="id-lc-material"
                size="small"
                value={
                  valueACLcMaterial && valueACLcMaterial.id
                    ? valueACLcMaterial
                    : null
                }
                onChange={(event, newValue) => {
                  setValueACLcMaterial(newValue);
                  setItemCrudLocal({
                    ...itemCrudLocal,
                    id_lc_material: newValue ? newValue.id : "",
                  });
                }}
                inputValue={inputValueACLcMaterial}
                onInputChange={(event, newInputValue) => {
                  setInputValueACLcMaterial(newInputValue);
                }}
                options={lcMateriales}
                getOptionLabel={(option) => option.label || ""}
                isOptionEqualToValue={(option, value) => {
                  if (!value || !value.id) return false;
                  return option.id === value.id;
                }}
                disableClearable={true}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Material"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              // evita que abra/cierre el dropdown
                              e.stopPropagation();
                              loadLcMateriales();
                            }}
                          >
                            <RefreshOutlinedIcon sx={{ fontSize: 18 }} />
                          </IconButton>
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12}>
              <Box
                sx={{ display: "flex", justifyContent: "flex-end", pt: 1 }}
              >
                <Button
                  sx={{ mr: 1 }}
                  variant="contained"
                  size="small"
                  onClick={handleSave}
                  startIcon={<Add />}
                >
                  Agregar
                </Button>

                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleCloseDialog}
                  startIcon={<CloseIcon />}
                >
                  Cerrar
                </Button>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default SolucionLimpiezaMaterialLCDialog;
